import { get } from 'lodash';

const root = state => get(state, 'CommonState.dragAndDrop');

export const getIsDragging = state => get(root(state), 'isDragging');

export const getDraggingMeta = state => get(root(state), 'meta');



// WEBPACK FOOTER //
// ./src/state/dragAndDrop/selectors.js